export default __webpack_public_path__ + "static/SR India - Heavy Metal - Statement-0acbf26669bf3c0cb77cbf63c3991101.pdf";